import Vue from "vue";
import dayjs from "dayjs";
import axios from "axios";

export const baseURL = `${window.location.origin}/api`;
Vue.prototype.$baseURL = baseURL;

let contentType = "application/json; charset=utf-8";

axios.defaults.baseURL = baseURL;
axios.defaults.headers["Content-Type"] = contentType;
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.interceptors.request.use(
  (config) => {
    let expiresIn = localStorage.auth_tokenExpiresIn;
    let currentIn = dayjs().format("YYYY-MM-DD HH:mm:ss");
    if (currentIn > expiresIn) {
      window.Vue.prototype.$logout();
      return null;
    }
    let filters = [`/auth/oauth/token`];
    if (!filters.includes(config.url)) {
      let token = localStorage.auth_token;
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function loadBlobText(data) {
  return new Promise(function (resolve, reject) {
    let content;
    let reader = new FileReader();
    reader.onload = function (event) {
      content = reader.result;
      resolve(content);
    };
    reader.readAsText(data);
  });
}

axios.interceptors.response.use(
  (res) => {
    let resData = res.data;
    if (resData.code && resData.message && resData.timeStamp) {
      let data = Vue.prototype.$crypto.decrypt(
        resData.data,
        `ren${resData.timeStamp}`
      );
      res.data = data ? JSON.parse(data) : null;
    }
    return res;
  },
  async (error) => {
    const { response: res } = error;
    let msg;
    if (res.data instanceof Blob) {
      msg = JSON.parse(await loadBlobText(res.data)).message;
    } else {
      msg = res && res.data ? res.data.message : "";
    }
    if (!res) res.status = 401;

    switch (res.status) {
      case 400:
        msg = res.data.message;
        if (msg.includes("请求参数异常")) return; //不显示报错信息
        break;
      case 401:
        msg = "登录超时，请重新登录";
        window.Vue.prototype.$logout();
        break;
    }

    return Promise.reject(msg);
  }
);

export const fetch = (url, method, config = {}) => {
  return axios({ url, method, ...config }).catch((message) => {
    if (!message || typeof message !== "string") return false;
    let isCommon = url.indexOf("/common/") > -1;
    let isTypeError = message.indexOf("TypeError") > -1;
    if (!isCommon || !isTypeError) {
      Vue.prototype.$message.closeAll();
      Vue.prototype.$message({
        message,
        type: "error",
        customClass: "message",
      });
    }
    return false;
  });
};

export const postFile = (url, data, config) =>
  axios.post(url, data, config).then((res) => res.data);
